<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-ph-clients">

        <page-title :title="'Twoi klienci'" :back="true"></page-title>

        <card-loyalty-signup v-if="loyaltyEnabled"></card-loyalty-signup>

        <slide-y-up-transition :duration="400" :delay="300">
            <ion-searchbar v-if="show"
                           mode="md"
                           placeholder="Wyszukaj klienta"
                           @input="handleSearch($event)">
            </ion-searchbar>
        </slide-y-up-transition>

        <div v-for="(item,index) in places" :key="item.slug">
            <item-ph-client
                    :index="index+1"
                    :name="item.name"
                    :slug="item.slug"
                    :tax_id="item.tax_id"
                    :ebi="item.ebi_number"
                    :street="item.street"
                    :city="item.city"
                    :province="item.province"
                    :full_address="item.full_address"
                    :brand="item.brand"
                    :active="item.loyalty_program ? item.loyalty_program.active : null"
                    :status="item.loyalty_program ? item.loyalty_program.status : null">
            </item-ph-client>
        </div>

        <slide-y-up-transition :duration="400" :delay="200">
            <p v-if="show && places.length === 0" class="text-center">Brak wyników.</p>
        </slide-y-up-transition>

    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import goTo from '@/mixins/goto';
    import PageTitle from '@/components/PageTitle.vue';
    import CardLoyaltySignup from '@/cards/CardLoyaltySignup';
    import ItemPhClient from '@/items/ItemPhClient';

    export default {
        name: 'PhClients',
        components: { PageTitle, CardLoyaltySignup, ItemPhClient },
        mixins: [goTo],
        data(){
            return {
                show: false,
                searchbarActive: false,
            }
        },
        computed: {
            ...mapGetters('profile', ['getProfile']),
            ...mapState({
                errors: state => state.clients.errors,
                loading: state => state.clients.loading,
                places: state => state.clients.places,
                navigation: state => state.config.navigation
            }),
            // TODO refactor to mixin or add flag "contract signups are open"
            loyaltyEnabled(){
              let result = null
              Object.entries(this.navigation).forEach(([key, arr]) => {
                arr.forEach((item) => {
                  if(item.route === "LoyaltyIndex"){
                    return result = (item.disabled == false) ? true : false
                  }
                })
              })
              return result
            }
        },
        mounted(){
            this.show = true;
            let payload = {'ph_slug' : this.getProfile.slug};
            this.$store.dispatch('clients/PH_CLIENTS_REQUEST', payload);
        },
        methods: {
            handleSearch(e){
                // handle input with simple debounce
                if(this.timeout) clearTimeout(this.timeout);
                let payload = {'ph_slug' : this.getProfile.slug, 'search' : e.target.value};
                this.timeout = setTimeout(() => {
                    this.$store.dispatch('clients/PH_CLIENTS_REQUEST', payload);
                }, 200);
            },
        },
        destroyed(){
            clearInterval(this.timeout)
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 8px 12px;
    }
    ion-card-header{
      --background: #ffffff;
    }
</style>